import { ComboItem } from '../../../../model';
import Common, { Stores } from '../../../common';
import { IResponse } from '../../../model';
import ServiceBase from '../../../servicebase';
import { ICotizador, IMedioPago } from '../model';

export default class CotizadorService extends ServiceBase {
  get = (data:{ id?: number }) : Promise<IResponse<ICotizador>> => 
    this.GetFetch<IResponse<ICotizador>>('entity/cotizador', data);

  combo = (data: { activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) : Promise<IResponse<ComboItem[]>> => 
    this.GetFetch<IResponse<ComboItem[]>>('clientes/cotizador/combo', data);

  all = () : Promise<IResponse<ICotizador[]>> => 
    Common.indexedDB.StoreControl.apiget(Stores.Cotizadores, () => this.GetFetch<IResponse<ICotizador[]>>('entity/cotizador/all', {}));

  upsert = (data:ICotizador) : Promise<IResponse<ICotizador>> => 
    this.PostFetch<IResponse<ICotizador>>('entity/cotizador', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/cotizador', data);

    
  mediopagos_actives = (data:{ idcotizador?: number }) : Promise<IResponse<IMedioPago[]>> => 
    this.GetFetch<IResponse<IMedioPago[]>>('entity/cotizador/mediopagos/actives', data);
}
